import e from "react";
import { getIconColor as d } from "./iconfont.es5470.js";
import f from "./iconfont.es5471.js";
const r = {
  display: "block"
}, x = ({ size: a = 16, useVw: l, useRem: o, color: n, withColor: c, removeClassName: t, disableSSR: m, style: i, ...p }) => {
  const P = i ? { ...r, ...i } : r;
  return /* @__PURE__ */ e.createElement(f, { disableSSR: m }, /* @__PURE__ */ e.createElement("svg", { "data-icon-id": "24px-P2Pjiaoyi", "data-icon-group": "GateHeader", "data-icon-version": "0.8.1", viewBox: "0 0 24 24", width: l ? ((a || 0) / 375 * 100).toFixed(5) + "vw" : a + (o ? "rem" : "px"), height: l ? ((a || 0) / 375 * 100).toFixed(5) + "vw" : a + (o ? "rem" : "px"), className: t ? "" : "iconpark-icon", style: P, fill: "none", ...p }, /* @__PURE__ */ e.createElement(
    "g",
    {
      className: t ? "" : "24px-P2Päº¤æ"
    },
    /* @__PURE__ */ e.createElement(
      "g",
      {
        className: t ? "" : "normal",
        fill: c ? d(n, 0, "#262933") : "#262933",
        datafollowfill: c ? d(n, 0, "#262933") : "#262933"
      },
      /* @__PURE__ */ e.createElement(
        "path",
        {
          clipRule: "evenodd",
          d: "M14.964 4.811a2.764 2.764 0 1 1 5.527 0 2.764 2.764 0 0 1-5.527 0Zm2.763-1.163a1.164 1.164 0 1 0 0 2.327 1.164 1.164 0 0 0 0-2.327Z",
          fillRule: "evenodd"
        }
      ),
      /* @__PURE__ */ e.createElement(
        "path",
        {
          d: "M7.5 2.702a4.89 4.89 0 0 0-4.891 4.891V8.82a.8.8 0 1 0 1.6 0V7.593a3.29 3.29 0 0 1 3.29-3.29h3.683a.8.8 0 1 0 0-1.6H7.5Zm11.045 18.782a3.255 3.255 0 0 0 3.255-3.255v-2.045a.8.8 0 1 0-1.6 0v2.046c0 .913-.74 1.654-1.655 1.654h-4.09a.8.8 0 1 0 0 1.6h4.09Z"
        }
      ),
      /* @__PURE__ */ e.createElement(
        "path",
        {
          clipRule: "evenodd",
          d: "M3.51 13.648a2.764 2.764 0 1 1 5.527 0 2.764 2.764 0 0 1-5.528 0Zm2.763-1.164a1.164 1.164 0 1 0 0 2.327 1.164 1.164 0 0 0 0-2.327Z",
          fillRule: "evenodd"
        }
      ),
      /* @__PURE__ */ e.createElement(
        "path",
        {
          d: "M3.8 21.011a2.473 2.473 0 0 1 4.945 0 .8.8 0 1 0 1.6 0 4.073 4.073 0 0 0-8.145 0 .8.8 0 1 0 1.6 0Zm11.455-8.836a2.473 2.473 0 0 1 4.945 0 .8.8 0 0 0 1.6 0 4.073 4.073 0 1 0-8.146 0 .8.8 0 0 0 1.6 0Z"
        }
      )
    )
  )));
}, Z = x;
export {
  Z as default
};
